import script from "./ConsultaBolsa.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultaBolsa.vue?vue&type=script&setup=true&lang=js"

import "./ConsultaBolsa.vue?vue&type=style&index=0&id=538612f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-538612f6"]])

export default __exports__